import Image from 'src/components/Image';
import cx from 'classnames';
import styles from './BillGraphic.module.scss';
import { useRef } from 'react';

export type BillState = 'empty' | 'thinking' | 'answer' | 'waiting' | 'error';

interface BillGraphicProps {
  billState: BillState;
}

const BillGraphic: React.FC<BillGraphicProps> = ({ billState }) => {
  const lastFlipTime = useRef(Date.now());
  const lastFlipFrame = useRef('happy');
  const nextFlipTime = useRef(Math.random() * 150 + 50);

  let billImage = 'happy';
  switch (billState) {
    case 'empty':
    case 'waiting':
      billImage = 'happy';
      break;
    case 'answer':
      if (Date.now() - lastFlipTime.current > nextFlipTime.current) {
        lastFlipTime.current = Date.now();
        nextFlipTime.current = Math.random() * 150 + 50;
        if (lastFlipFrame.current === 'happy') {
          lastFlipFrame.current = 'mouth-open';
        } else {
          lastFlipFrame.current = 'happy';
        }
      }
      billImage = lastFlipFrame.current;

      break;
    case 'thinking':
      billImage = 'thinking';
      break;
    case 'error':
      billImage = 'sad';
      break;
  }
  return (
    <Image
      className={cx(
        styles.billImage,
        (billState == 'answer' ||
          billState == 'thinking' ||
          billState === 'error') &&
          styles.toTheSide,
        billState == 'waiting' && styles.waiting,
      )}
      src={`/assets/img/docs/bill-${billImage}.png`}
      alt='Ask Bill!'
      isLazy={false}
      width={95}
    />
  );
};

BillGraphic.displayName = 'BillGraphic';

export default BillGraphic;
